import ru from './ru.json'
import en from './en.json'
import lv from './lv.json'
import type { Catalog, Lang } from './types'

/**
 * Каталоги в бандле, а не по сети: их три, вместе они весят меньше одного
 * запроса, зато переключение мгновенное и первый экран не мигает. Ленивая
 * подгрузка понадобится языке на десятом — не раньше.
 */
export const CATALOGS: Record<Lang, Catalog> = {
  ru: ru as Catalog,
  en: en as Catalog,
  lv: lv as Catalog,
}

export function catalogFor(lang: Lang): Catalog {
  return CATALOGS[lang] ?? CATALOGS.ru
}
